<template>
    <div class="login-body" v-loading.fullscreen.lock="is_loading">
        <!-- ログインフォーム -->
        <div class="form-area">
            <div class="logo-block">
                <img class="logo-image" src="/images/logo_login.png" />
            </div>

            <!-- フォームブロック -->
            <div class="form-block">
                <el-form ref="login_form" :rules="rules" :model="login_form">
                    <!-- ログインエラーメッセージ -->
                    <div class="error-message-block">
                        <template v-if="error_message">{{ error_message }}</template>
                    </div>
                    <!-- メールアドレス -->
                    <el-form-item :label="$t('attributes.mail_address')" prop="email">
                        <el-input
                            class="input-text-m"
                            v-model="login_form.email"
                            ref="email"
                            @keyup.enter.native="login"
                        />
                    </el-form-item>

                    <!-- パスワード -->
                    <el-form-item :label="$t('attributes.password')" prop="password">
                        <el-input
                            class="input-text-m"
                            v-model="login_form.password"
                            ref="password"
                            @keyup.enter.native="login"
                            type="password"
                        />
                    </el-form-item>

                    <template v-if="use_recaptcha">
                        <vue-recaptcha
                            class="g-recaptcha"
                            ref="recaptcha"
                            :sitekey="recaptcha_site_key"
                            @verify="onVerify"
                            @expired="onExpired"
                        ></vue-recaptcha>
                    </template>

                    <!-- ログインボタン -->
                    <el-form-item>
                        <el-button type="primary" @click="login" :disabled="!is_enable_buttom">{{
                            $t('login.index.login')
                        }}</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 各リンクブロック -->
            <div class="link-block">
                <!-- パスワードリセットページへ遷移 -->
                <div>
                    <router-link :to="{ name: 'password-reissue' }">{{ $t('login.index.reset_password') }}</router-link>
                </div>

                <!-- ロック解除方法ページへ遷移 -->
                <div>
                    <a href="https://faq.list-finder.jp/faq/103" target="_blank">{{
                        $t('login.index.release_lock')
                    }}</a>
                </div>
            </div>

            <!-- 説明ブロック -->
            <div class="description-block">
                <!-- reCAPTCHA使用 -->
                <template v-if="use_recaptcha">
                    <!-- 不正ログイン対策のご協力のお願い -->
                    <div class="bold">{{ $t('login.index.description_recaptcha_title') }}</div>
                    <div v-html="$t('login.index.description_recaptcha_content')" />
                </template>
                <!-- reCAPTCHA不使用 -->
                <template v-else>
                    <!-- reCAPTCHA不使用メッセージ -->
                    <div v-html="$t('login.index.description_nonuse_recaptcha')" />

                    <!-- お問い合わせ詳細 -->
                    <div v-html="$t('login.index.description_question')" />
                    <a href="https://faq.list-finder.jp/contact">https://faq.list-finder.jp/contact</a>
                </template>
            </div>
        </div>

        <!-- 広告 -->
        <div class="ad-area">
            <div class="ad-block">
                <iframe :src="iframe_src" scrolling="no" frameborder="0" class="ad-iframe" />
            </div>
        </div>
    </div>
</template>

<style lang="sass">
/* CSSファイルの読み込み */
@import '../../../sass/auth/login/index.scss'
</style>

<script>
import common from '../../common/common';
import getComponentItem from '../../common/getComponentItem';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

export default {
    components: { VueRecaptcha },
    created() {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute(
            'src',
            'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
        );
        document.head.appendChild(recaptchaScript);
    },
    computed: {
        /**
         * iframe のURLを取得（ランダム）
         * 本番と開発環境は、本番のプロモートサイトを参照
         * ステージングのみ、テストのプロモートサイトを参照
         */
        iframe_src() {
            // 本番用URL
            let url_list = [
                'https://promote.list-finder.jp/listfinder_loginpageaside_4-1/',
                'https://promote.list-finder.jp/listfinder_loginpageaside_4-2/',
                'https://promote.list-finder.jp/listfinder_loginpageaside_4-3/',
                'https://promote.list-finder.jp/listfinder_loginpageaside_4-4/'
            ];

            return url_list[Math.floor( Math.random() * url_list.length )];
        },
        page_title() {
            return this.$t('login.index.login');
        }
    },
    async mounted() {
        document.title = this.page_title;

        if (this.$refs.email.value.length === 0) {
            // メールアドレス入力をフォーカス
            this.$refs.email.focus();
        } else {
            // パスワード入力をフォーカス
            this.$refs.password.focus();
        }
        const {data} = await axios.get('/common/api/get-item/recaptcha');
        this.recaptcha_site_key = data.recaptcha_site_key;
        this.use_recaptcha = data.use_recaptcha;

        if (this.use_recaptcha === false) {
            this.is_enable_buttom = true;
        }
    },
    data() {
        return {
            recaptcha_site_key:'',
            use_recaptcha: false,
            is_loading: false,
            recaptcha_token: '',
            error_message: '',
            login_form: {
                email: '',
                password: ''
            },
            is_enable_buttom: false,
            rules: {
                email: [
                    {
                        required: true,
                        message: this.$t('login.index.errors.email_required'),
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: this.$t('login.index.errors.email_incorrect_format'),
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: this.$t('login.index.errors.password_required'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        // ログイン処理
        login() {
            this.$refs['login_form'].validate(valid => {
                if (valid) {
                    this.is_loading = true;

                    const params = {
                        email: this.login_form.email,
                        password: this.login_form.password,
                        token: this.recaptcha_token,
                    };

                    axios
                        .post('/api/login', params)
                        .then(response => {
                            const result = response.data.resource;
                            const error_msg = this.getErrorMsg(result);
                            // error case
                            if (error_msg !== '') {
                                this.error_message = this.$t(error_msg);
                                this.resetRecaptcha();
                                return;
                            }
                            // no error
                            // config情報をセット
                            // ユーザー権限情報をセット
                            this.setUserAuthorities(
                                result.config_information,
                                result.user_basic_information,
                                result.user_authorities,
                                result.listview_remain_information,
                                result.plan_trial_remain_information
                            );

                            // エラーが存在しない場合はリダイレクト
                            location.replace(result.redirect_url);
                        })
                        .catch(error => {
                            this.$message.error({
                                showClose: true,
                                message: common.getErrorMessage(error.response.data)
                            });
                            this.resetRecaptcha();
                        })
                        .finally(() => this.is_loading = false);
                }
            });
        },
        onVerify(response) {
            this.recaptcha_token = response; //レスポンスのトークンをセット
            this.is_enable_buttom = true;
        },
        onExpired() {
            this.recaptcha_token = ''; //レスポンスのトークンを空に戻す
            this.is_enable_buttom = false; //submitボタンをdisabledに
        },
        resetRecaptcha() {
            this.is_enable_buttom = false;
            if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset();
            }
        },
        getErrorMsg(result) {
            // エラー内容によって表示するメッセージを切り分ける
            if (result.incorrect_email_or_password) {
                return 'login.index.error_messages.incorrect_email_or_password';
            }
            if (result.outside_viewing_period) {
                return 'login.index.error_messages.outside_viewing_period';
            }
            if (result.outside_trial_period) {
                return 'login.index.error_messages.outside_trial_period';
            }
            if (result.lock_account) {
                return 'login.index.error_messages.lock_account';
            }
            if (result.recaptcha_failed) {
                return 'login.index.error_messages.recaptcha_failed';
            }
            if (result.disallow_access_ip) {
                return 'login.index.error_messages.disallow_access_ip';
            }
            if (result.failed_login) {
                return 'login.index.error_messages.failed_login';
            }
            // errorがない場合は空文字を返す
            return '';
        },
        // ユーザー権限情報をvuexに格納する
        setUserAuthorities(config_information, user_basic_information, user_authorities, listview_remain_information, plan_trial_remain_information) {
            if (user_authorities.is_user) {
                this.$store.commit('user/user_config/setConfigInformation', config_information);
                this.$store.commit('user/user_basic_information/setUserBasicInformation', user_basic_information);
                this.$store.commit('user/user_authorities/setAuthorities', user_authorities);
                this.$store.commit('user/listview_remain_information/setListviewRemainInformation', listview_remain_information);
                this.$store.commit('user/plan_trial_remain_information/setPlanTrialRemainInformation', plan_trial_remain_information);
            } else if (user_authorities.is_admin) {
                this.$store.commit('admin/admin_config/setConfigInformation', config_information);
                this.$store.commit('admin/admin_basic_information/setUserBasicInformation', user_basic_information);
                this.$store.commit('admin/admin_authorities/setAuthorities', user_authorities);
            }
        }
    }
};
</script>
